import {useState} from 'react';
import styles from './DashboardDropDownStyle.module.css';
import chevronUp from '../../../assets/images/chevron-up.svg';
import chevronDown from '../../../assets/images/chevron-down.svg';
import rightChevronYellowFilled from '../../../assets/images/rightChevronYellowFilled.svg';
import {Currency} from '../../components/Formatters';
import graphql from 'babel-plugin-relay/macro';
import {DashboardDropDown_category} from './__generated__/DashboardDropDown_category.graphql';

interface Props {
  openDataModal: (open: string) => null;
  content: Omit<DashboardDropDown_category, ' $refType'>;
}
export const DashboardDropDown = ({openDataModal, content}: Props) => {
  const [open, setOpen] = useState(false);

  return !content.totalRollup.isNull ? (
    <div className={open ? styles.root : styles.rootClosed}>
      <div
        className={styles.header}
        role="button"
        tabIndex={0}
        onClick={() => setOpen(!open)}
      >
        <div>
          <p
            className={styles.dropdownHeading}
            onClick={(e) => {
              e.stopPropagation();
              openDataModal(content.totalRollup!.name.toUpperCase());
            }}
          >
            {content.totalRollup?.name}{' '}
            <img
              src={rightChevronYellowFilled}
              className={styles.filledChevron}
            />
          </p>
          <div className={styles.subHeadingMainContainer}>
            <div className={styles.subHeadingContainer}>
              <p className={styles.dropdownSubHeadingsAmount}>
                {Currency({
                  children: content.totalRollup!.yesterdaysSalesToDate,
                })}
              </p>
              <p className={styles.dropdownSubHeadingsTime}> YsTD</p>
            </div>
            <hr className={styles.underline} />
            <div className={styles.subHeadingContainer}>
              <p className={styles.dropdownSubHeadingsAmount}>
                {Currency({
                  children: content.totalRollup!.currentMonthToDate,
                })}
              </p>
              <p className={styles.dropdownSubHeadingsTime}> MTD</p>
            </div>
            <hr className={styles.underline} />
            <div className={styles.subHeadingContainer}>
              <p className={styles.dropdownSubHeadingsAmount}>
                {Currency({
                  children: content.totalRollup!.lastMonthMonthToDate,
                })}
              </p>
              <p className={styles.dropdownSubHeadingsTime}> lastMTD</p>
            </div>
            <hr className={styles.underline} />
            <div className={styles.subHeadingContainer}>
              <p className={styles.dropdownSubHeadingsAmount}>
                {Currency({children: content.totalRollup!.lastMonth})}
              </p>
              <p className={styles.dropdownSubHeadingsTime}> LMth</p>
            </div>
          </div>
        </div>
        <img className={styles.chevron} src={open ? chevronUp : chevronDown} />
      </div>
      {open &&
        content.categories?.map((values, index) => {
          return (
            !values?.isNull && (
              <div
                className={styles.dropdownContentHeader}
                role="button"
                tabIndex={0}
                key={index}
              >
                <div className={styles.dropDownContainer}>
                  <p
                    className={styles.dropdownHeading}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (values) {
                        openDataModal(values.key.toUpperCase());
                      }
                    }}
                  >
                    {values?.name}{' '}
                    <img
                      src={rightChevronYellowFilled}
                      className={styles.filledChevron}
                    />
                  </p>
                  <div className={styles.subHeadingMainContainer}>
                    <div className={styles.subHeadingContainer}>
                      <p className={styles.dropdownSubHeadingsAmount}>
                        {Currency({children: values!.yesterdaysSalesToDate})}
                      </p>
                      <p className={styles.dropdownSubHeadingsTime}> YsTD</p>
                    </div>
                    <hr className={styles.underline} />
                    <div className={styles.subHeadingContainer}>
                      <p className={styles.dropdownSubHeadingsAmount}>
                        {Currency({children: values!.currentMonthToDate})}
                      </p>
                      <p className={styles.dropdownSubHeadingsTime}> MTD</p>
                    </div>
                    <hr className={styles.underline} />
                    <div className={styles.subHeadingContainer}>
                      <p className={styles.dropdownSubHeadingsAmount}>
                        {Currency({children: values!.lastMonthMonthToDate})}
                      </p>
                      <p className={styles.dropdownSubHeadingsTime}> lastMTD</p>
                    </div>
                    <hr className={styles.underline} />
                    <div className={styles.subHeadingContainer}>
                      <p className={styles.dropdownSubHeadingsAmount}>
                        {Currency({children: values!.lastMonth})}
                      </p>
                      <p className={styles.dropdownSubHeadingsTime}> LMth</p>
                    </div>
                  </div>
                </div>
              </div>
            )
          );
        })}
    </div>
  ) : (
    <></>
  );
};
graphql`
  fragment DashboardDropDown_sales on DetailedSalesReportSales {
    isNull
    name
    key
    yesterdaysSalesToDate
    currentMonthToDate
    lastMonthMonthToDate
    lastMonth
  }
`;
graphql`
  fragment DashboardDropDown_category on DetailedSalesReportCategory {
    categories {
      ...DashboardDropDown_sales @relay(mask: false)
    }
    totalRollup {
      ...DashboardDropDown_sales @relay(mask: false)
    }
  }
`;
graphql`
  fragment DashboardDropDown_report on DetailedSalesReport {
    categories {
      airtime {
        ...DashboardDropDown_category
      }
      data {
        ...DashboardDropDown_category
      }
      entertainment {
        ...DashboardDropDown_category
      }
      ticketing {
        ...DashboardDropDown_category
      }
      billPayments {
        ...DashboardDropDown_category
      }
      electricity {
        ...DashboardDropDown_category
      }
      other {
        ...DashboardDropDown_category
      }
    }
  }
`;
